// Visitor identity + a courtesy refresh guard for the public view beacon.
// The server's atomic dedup is the authoritative protection; this just avoids
// pinging the server on every refresh.

const VISITOR_KEY = "tp.visitorId";
const DEDUP_WINDOW_MS = 6 * 60 * 60 * 1000; // mirror the server window

export function getVisitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    // Storage blocked (private mode); fall back to a per-load random id. The
    // server's IP/UA cap still bounds abuse.
    return crypto.randomUUID();
  }
}

export function recentlyBeaconed(shortId: string, now: number): boolean {
  try {
    const raw = localStorage.getItem(`tp.viewBeacon.${shortId}`);
    return raw ? now - Number(raw) < DEDUP_WINDOW_MS : false;
  } catch {
    return false;
  }
}

export function markBeaconed(shortId: string, now: number): void {
  try {
    localStorage.setItem(`tp.viewBeacon.${shortId}`, String(now));
  } catch {
    // ignore
  }
}
